export default {"src":"/_next/static/image/public/images/flags/flag_49.cd1e4fe0aa2420a78167769ce596acfe.svg","height":16,"width":24};